import { render } from "./index.vue?vue&type=template&id=582a1be2"
const script = {}

import "./index.vue?vue&type=style&index=0&id=582a1be2&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__